const translations = {
  en: {
    nav_open_studio: "Open Studio",
    nav_studio: "Studio",
    nav_home: "Home",

    hero_tagline: "Create Without Limits",
    hero_subtitle: "Transform your imagination into stunning images and videos powered by the most advanced AI.",
    hero_cta: "Start Creating",

    tab_image: "Image Generation",
    tab_video: "Video Generation",

    img_step1_title: "Describe Your Image",
    img_prompt_label: "Image Prompt",
    img_prompt_placeholder: "Describe the image you want to create. Be detailed for best results. Example: 'A serene Japanese garden at golden hour with cherry blossoms reflecting in still water, soft mist, cinematic lighting.'",
    img_style_label: "Visual Style",
    img_style_placeholder: "e.g. cinematic, watercolor, photorealistic, anime, oil painting, minimalist, baroque...",
    img_aspect_label: "Composition",
    img_generate_btn: "Generate Image",
    img_generating: "Crafting your image...",

    img_suggestions_label: "Try these prompts:",
    img_sug1: "A serene Japanese garden at dawn with cherry blossoms",
    img_sug2: "An elegant dancer in silk performing in an ancient palace",
    img_sug3: "Underwater scene with bioluminescent jellyfish in deep ocean",
    img_sug4: "A minimalist golden desert at sunset with long shadows",

    vid_step1_title: "Describe Your Video",
    vid_step1_desc: "Main required field",
    vid_step2_title: "Optional Creative Controls",
    vid_step2_desc: "Shape the final result",
    vid_step3_title: "Aspect Ratio",
    vid_step4_title: "Advanced Settings",
    vid_step5_title: "Generate",

    vid_prompt_label: "Video Prompt Description",
    vid_prompt_placeholder: "Describe the video you want to create. Include subject, environment, motion, mood, lighting, camera angle. Example: 'A futuristic city at sunset with flying cars and glowing neon reflections, cinematic drone shot.'",
    vid_prompt_note: "Be as descriptive as possible for better results.",

    vid_audio_label: "Sound & Audio Details",
    vid_audio_placeholder: "Describe background music, sound effects, ambient noise, or dialogue. Example: cinematic orchestra, thunder sounds, soft narration, crowd noise.",
    vid_style_label: "Visual Style",
    vid_style_placeholder: "Specify the visual style. Example: cinematic, anime, hyper-realistic, 3D animation, watercolor, dark fantasy, cyberpunk.",
    vid_motion_label: "Motion & Camera Behavior",
    vid_motion_placeholder: "Describe camera movement and scene motion. Example: slow zoom in, drone shot, panning left, handheld motion, dramatic tracking shot.",

    vid_duration_label: "Video Duration",
    vid_quality_label: "Output Quality",
    vid_audio_toggle: "Include Audio",
    vid_quality_standard: "Standard (Faster)",
    vid_quality_high: "High Quality (Slower)",

    vid_generate_btn: "Generate Video",
    vid_generating: "Crafting your vision with Sora 2...",
    vid_generating_sub: "This may take 2-5 minutes. Please wait.",
    vid_elapsed: "Elapsed",

    vid_suggestions_label: "Try these prompts:",
    vid_sug1: "A majestic eagle soaring over snowy mountains at sunrise",
    vid_sug2: "Ocean waves crashing on a deserted beach at golden hour",
    vid_sug3: "A peaceful forest with sunlight filtering through ancient trees",
    vid_sug4: "City time-lapse at night with light trails and glowing streets",

    ar_landscape: "Landscape",
    ar_portrait: "Portrait",
    ar_square: "Square",

    out_prompt_summary: "Generated Prompt",
    out_copy: "Copy Prompt",
    out_download: "Download",
    out_another: "Generate Another Version",
    out_new: "New Project",
    out_copied: "Copied!",
    out_image_ready: "Your image is ready",
    out_video_ready: "Your video is ready",

    optional: "Optional",
    expand: "Expand",
    collapse: "Collapse",
    error_no_prompt: "Please describe what you want to generate.",
    error_generation: "Generation failed. Please try again.",
    ref_image_label: "Reference Image",
    ref_image_desc: "Upload an image to inspire the generation",
    ref_image_remove: "Remove",
    duration_4s: "4 seconds",
    duration_8s: "8 seconds",
    duration_12s: "12 seconds",
    powered_by: "Powered by",
    free_label: "100% Free",
    scroll_down: "Scroll to explore",

    // Auth
    auth_login: "Sign In",
    auth_register: "Create Account",
    auth_email: "Email",
    auth_password: "Password",
    auth_name: "Full Name",
    auth_login_btn: "Sign In",
    auth_register_btn: "Create Account",
    auth_logout: "Sign Out",
    auth_switch_to_register: "Don't have an account? Sign up",
    auth_switch_to_login: "Already have an account? Sign in",
    auth_welcome: "Welcome back",
    auth_create: "Join KHATIRA",
    auth_required: "Sign in to start creating",
    auth_required_desc: "Create an account or sign in to access AI generation tools.",
    auth_change_password: "Change Password",
    auth_current_password: "Current Password",
    auth_new_password: "New Password",
    auth_confirm_new_password: "Confirm New Password",
    auth_password_changed: "Password changed successfully",
    auth_passwords_no_match: "New passwords do not match",
    auth_forgot_title: "Reset your password",
    auth_reset_title: "Set a new password",
    auth_send_reset: "Send Reset Token",
    auth_reset_btn: "Reset Password",
    auth_forgot_link: "Forgot your password?",
    auth_back_to_login: "Back to sign in",
    auth_reset_success: "Password reset! You can now sign in.",

    // Gallery
    gallery_images: "My Images",
    gallery_videos: "My Videos",
    gallery_empty_images: "No images yet. Start creating!",
    gallery_empty_videos: "No videos yet. Start creating!",

    // Admin
    admin_title: "Admin",
    admin_users: "Users",
    admin_name: "Name",
    admin_email: "Email",
    admin_generations: "Total",
    admin_images: "Images",
    admin_videos: "Videos",
    admin_joined: "Joined",
    admin_role: "Role",
    admin_delete: "Delete",
    admin_confirm: "Confirm",
    admin_cancel: "Cancel",
    admin_no_users: "No users found",
  },

  ar: {
    nav_open_studio: "افتح الاستوديو",
    nav_studio: "الاستوديو",
    nav_home: "الرئيسية",

    hero_tagline: "أبدع بلا حدود",
    hero_subtitle: "حوّل مخيّلتك إلى صور ومقاطع فيديو مذهلة بقوة أحدث تقنيات الذكاء الاصطناعي.",
    hero_cta: "ابدأ الإبداع",

    tab_image: "توليد الصور",
    tab_video: "توليد الفيديو",

    img_step1_title: "صف صورتك",
    img_prompt_label: "وصف الصورة",
    img_prompt_placeholder: "صف الصورة التي تريد إنشاءها بتفصيل. مثال: 'حديقة يابانية هادئة في ساعة الذهب مع أزهار الكرز تنعكس في الماء الساكن، ضباب خفيف، إضاءة سينمائية.'",
    img_style_label: "الأسلوب البصري",
    img_style_placeholder: "مثال: سينمائي، ألوان مائية، واقعي للغاية، أنمي، رسم زيتي، بسيط...",
    img_aspect_label: "التركيب",
    img_generate_btn: "توليد الصورة",
    img_generating: "جارٍ إنشاء صورتك...",

    img_suggestions_label: "جرّب هذه الأوصاف:",
    img_sug1: "حديقة يابانية هادئة عند الفجر مع أزهار الكرز",
    img_sug2: "راقصة أنيقة بالحرير تؤدي في فناء قصر قديم",
    img_sug3: "منظر تحت الماء مع قناديل بحر بيولوميسنت",
    img_sug4: "صحراء ذهبية بسيطة عند غروب الشمس بظلال طويلة",

    vid_step1_title: "صف الفيديو",
    vid_step1_desc: "الحقل الأساسي المطلوب",
    vid_step2_title: "خيارات إبداعية",
    vid_step2_desc: "شكّل النتيجة النهائية",
    vid_step3_title: "نسبة الأبعاد",
    vid_step4_title: "إعدادات متقدمة",
    vid_step5_title: "التوليد",

    vid_prompt_label: "وصف الفيديو",
    vid_prompt_placeholder: "صف الفيديو الذي تريد إنشاءه. اذكر الموضوع، البيئة، الحركة، الأجواء، الإضاءة، زاوية الكاميرا. مثال: 'مدينة مستقبلية عند غروب الشمس مع سيارات طائرة وانعكاسات نيون متوهجة.'",
    vid_prompt_note: "كلما كان وصفك أكثر تفصيلاً، كانت النتائج أفضل.",

    vid_audio_label: "تفاصيل الصوت والموسيقى",
    vid_audio_placeholder: "صف الموسيقى الخلفية، المؤثرات الصوتية، الأصوات المحيطة. مثال: أوركسترا سينمائية، صوت الرعد، سرد هادئ.",
    vid_style_label: "الأسلوب البصري",
    vid_style_placeholder: "حدد الأسلوب البصري. مثال: سينمائي، أنمي، واقعي للغاية، رسوم ثلاثية الأبعاد، ألوان مائية.",
    vid_motion_label: "الحركة وسلوك الكاميرا",
    vid_motion_placeholder: "صف حركة الكاميرا والمشهد. مثال: تكبير بطيء، لقطة طائرة، تحريك يساري، حركة يدوية.",

    vid_duration_label: "مدة الفيديو",
    vid_quality_label: "جودة الإخراج",
    vid_audio_toggle: "تضمين الصوت",
    vid_quality_standard: "عادي (أسرع)",
    vid_quality_high: "جودة عالية (أبطأ)",

    vid_generate_btn: "توليد الفيديو",
    vid_generating: "جارٍ إنشاء مقطعك بـ Sora 2...",
    vid_generating_sub: "قد يستغرق هذا من دقيقتين إلى خمس دقائق. يرجى الانتظار.",
    vid_elapsed: "الوقت المنقضي",

    vid_suggestions_label: "جرّب هذه الأوصاف:",
    vid_sug1: "نسر مهيب يحلّق فوق جبال ثلجية عند شروق الشمس",
    vid_sug2: "أمواج المحيط تتكسّر على شاطئ مهجور في ساعة الذهب",
    vid_sug3: "غابة هادئة مع ضوء الشمس يتسلل عبر الأشجار العتيقة",
    vid_sug4: "مدينة ليلاً بالانتقال الزمني مع مسارات ضوئية وشوارع متوهجة",

    ar_landscape: "أفقي",
    ar_portrait: "عمودي",
    ar_square: "مربع",

    out_prompt_summary: "الوصف النهائي",
    out_copy: "نسخ الوصف",
    out_download: "تحميل",
    out_another: "توليد نسخة أخرى",
    out_new: "مشروع جديد",
    out_copied: "تم النسخ!",
    out_image_ready: "صورتك جاهزة",
    out_video_ready: "مقطع الفيديو جاهز",

    optional: "اختياري",
    expand: "توسيع",
    collapse: "طيّ",
    error_no_prompt: "يرجى وصف ما تريد إنشاءه.",
    error_generation: "فشل التوليد. يرجى المحاولة مجدداً.",
    ref_image_label: "صورة مرجعية",
    ref_image_desc: "ارفع صورة لإلهام التوليد",
    ref_image_remove: "إزالة",
    duration_4s: "٤ ثوانٍ",
    duration_8s: "٨ ثوانٍ",
    duration_12s: "١٢ ثانية",
    powered_by: "مدعوم بـ",
    free_label: "مجاني ١٠٠٪",
    scroll_down: "انتقل للأسفل",

    // Auth
    auth_login: "تسجيل الدخول",
    auth_register: "إنشاء حساب",
    auth_email: "البريد الإلكتروني",
    auth_password: "كلمة المرور",
    auth_name: "الاسم الكامل",
    auth_login_btn: "تسجيل الدخول",
    auth_register_btn: "إنشاء حساب",
    auth_logout: "تسجيل الخروج",
    auth_switch_to_register: "ليس لديك حساب؟ أنشئ واحداً",
    auth_switch_to_login: "لديك حساب بالفعل؟ سجّل الدخول",
    auth_welcome: "مرحباً بعودتك",
    auth_create: "انضم إلى خاطرة",
    auth_required: "سجّل الدخول لبدء الإبداع",
    auth_required_desc: "أنشئ حساباً أو سجّل الدخول للوصول إلى أدوات التوليد بالذكاء الاصطناعي.",
    auth_change_password: "تغيير كلمة المرور",
    auth_current_password: "كلمة المرور الحالية",
    auth_new_password: "كلمة المرور الجديدة",
    auth_confirm_new_password: "تأكيد كلمة المرور الجديدة",
    auth_password_changed: "تم تغيير كلمة المرور بنجاح",
    auth_passwords_no_match: "كلمتا المرور غير متطابقتين",
    auth_forgot_title: "إعادة تعيين كلمة المرور",
    auth_reset_title: "تعيين كلمة مرور جديدة",
    auth_send_reset: "إرسال رمز إعادة التعيين",
    auth_reset_btn: "إعادة تعيين كلمة المرور",
    auth_forgot_link: "نسيت كلمة المرور؟",
    auth_back_to_login: "العودة لتسجيل الدخول",
    auth_reset_success: "تم إعادة تعيين كلمة المرور! يمكنك الآن تسجيل الدخول.",

    // Gallery
    gallery_images: "صوري",
    gallery_videos: "مقاطعي",
    gallery_empty_images: "لا توجد صور بعد. ابدأ بالإبداع!",
    gallery_empty_videos: "لا توجد مقاطع بعد. ابدأ بالإبداع!",

    // Admin
    admin_title: "لوحة الإدارة",
    admin_users: "المستخدمين",
    admin_name: "الاسم",
    admin_email: "البريد الإلكتروني",
    admin_generations: "الإجمالي",
    admin_images: "الصور",
    admin_videos: "المقاطع",
    admin_joined: "تاريخ الانضمام",
    admin_role: "الدور",
    admin_delete: "حذف",
    admin_confirm: "تأكيد",
    admin_cancel: "إلغاء",
    admin_no_users: "لا يوجد مستخدمون",
  },
};

export default translations;
